import { Link, Text } from "@postenbring/hedwig-react";

const ParcelBoxResult = ({ res, mapLabel }) => (
    <ul className="kp-parcel-box-result" aria-live="polite">
        {res.map((item) => (
            <li key={item.mapUrl}>
                <Text variant="body-title">{item.name}</Text>
                <Text>{item.location}</Text>
                <Text>
                    {item.address}, {item.postCode} {item.city}
                </Text>
                <Link href={item.mapUrl} target="_blank">
                    {mapLabel}
                </Link>
            </li>
        ))}
    </ul>
);

export default ParcelBoxResult;
